function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z M6.9231576,10.2058612 C6.50450572,9.74739683 5.80149516,9.72261957 5.35293957,10.1505196 C4.90438398,10.5784197 4.88014224,11.29696 5.29879412,11.7554243 L7.93220861,14.6392681 C8.37141716,15.120244 9.11736353,15.120244 9.55657208,14.6392681 L15.7012059,7.91029928 C16.1198578,7.45183494 16.095616,6.73329464 15.6470604,6.30539459 C15.1985048,5.87749454 14.4954943,5.90227179 14.0768424,6.36073613 L8.74439035,12.2002873 L6.9231576,10.2058612 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ok.2c7560f7.svg";
export { SvgComponent as ReactComponent };